import { LayoutTriggerValueType } from 'defs/layout';
import { initialState, RootStateType } from '.';
import { LayoutStateType } from '.';

export const getState = (state: RootStateType): LayoutStateType => state.layout || initialState;
export const getIsBodyLocked = (state: RootStateType): boolean | null => getState(state).bodyLocked;
export const getGoTopTimestamp = (state: RootStateType): string | null => getState(state).goTop;
export const getCurrentOptions = (state: RootStateType): Object => getState(state).opts || {};
export const getTriggerComponent = (state: RootStateType): LayoutTriggerValueType | undefined =>
	getState(state).triggerComponent;
